module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/trophy-brigade-lvl1-50.83da6a28.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/trophy-brigade-lvl1-50.png
// module id = 3580
// module chunks = 11